import { isType } from '@mtna/core-ts';
import { Variable } from '@mtna/pojo-consumer-ts';
import { VariableSummary } from '@mtna/variable-service-core-ts';

import { BaseFilter } from './base-filter.model';
import { RdsDateFilter } from './date-filter.model';
import { RdsNullFilter } from './null-filter.model';

export class FilterByDate<V extends Variable | VariableSummary> extends BaseFilter<V> {
  constructor(variable: V, public dateFilters: Array<RdsDateFilter>, nullFilter?: RdsNullFilter) {
    super(variable, nullFilter);
  }
}

export function instanceOfFilterByDate(something: unknown): something is FilterByDate<Variable | VariableSummary> {
  return isType<FilterByDate<Variable | VariableSummary>>(something, 'variable', 'dateFilters');
}
